module.exports = __webpack_public_path__ + "static/media/arrow.87d9ff5f.svg";